import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import { LockIcon } from '@phosphor-icons/react/Lock';

const StyledDivider = styled(Divider)`
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

type LockProps = {
  divider?: boolean;
  marginRight?: boolean;
  gray?: boolean;
};

export const Lock = ({ divider, marginRight, gray }: LockProps) => {
  return (
    <>
      <Box
        component={LockIcon}
        size={16}
        data-test="locked-icon"
        sx={theme => ({
          color: gray ? theme.palette.text.secondary : 'inherit',
          flexShrink: 0,
          marginRight: marginRight ? 1 : 0,
          verticalAlign: 'sub',
        })}
      />
      {divider && <StyledDivider orientation="vertical" />}
    </>
  );
};
